enum ProfileTabType {
  Created = "Created",
  Collected = "Collected",
  WalletViewer = "Wallet Viewer",
}

export default ProfileTabType;
